export default __webpack_public_path__ + "static/media/powerlines.7312d273.png";